'use client';
import React from 'react';
import HomePage from './_page';

import './home.css';

export default function Page() {
  return <HomePage />;
}
